import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, EMPTY, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { ResourcesHttpService } from '../../http/resources/resources-http.service';
import {
  NmcNmbiStatusActions,
  NmcNmbiStatusAPIActions,
} from '../actions/nmc-nmbi-status.actions';
import { SharedSelectors } from '../selectors/index';

@Injectable()
export class NmcNmbiStatusEffects {
  public loadNMCStatus$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(NmcNmbiStatusActions.loadNMCNMBIStatus),
      switchMap(() => this._store.select(SharedSelectors.selectHasNMCSkill)),
      switchMap((hasNMCSkill) =>
        hasNMCSkill
          ? this._resourcesHttpService.nmcStatus$.pipe(
              mergeMap((nmcStatus) =>
                of(
                  NmcNmbiStatusAPIActions.loadedNMCStatusSuccessfully({
                    nmcStatus,
                  }),
                ),
              ),
              catchError((error) =>
                of(
                  NmcNmbiStatusAPIActions.loadedNMCStatusUnsuccessfully({
                    error,
                  }),
                ),
              ),
            )
          : EMPTY,
      ),
    ),
  );

  public loadNMBIStatus$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(NmcNmbiStatusActions.loadNMCNMBIStatus),
      switchMap(() => this._store.select(SharedSelectors.selectHasNMBISkill)),
      switchMap((hasNMBISkill) =>
        hasNMBISkill
          ? this._resourcesHttpService.nmbiStatus$.pipe(
              mergeMap((nmbiStatus) =>
                of(
                  NmcNmbiStatusAPIActions.loadedNMBIStatusSuccessfully({
                    nmbiStatus,
                  }),
                ),
              ),
              catchError((error) =>
                of(
                  NmcNmbiStatusAPIActions.loadedNMBIStatusUnsuccessfully({
                    error,
                  }),
                ),
              ),
            )
          : EMPTY,
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _resourcesHttpService: ResourcesHttpService,
    private _store: Store,
  ) {}
}
